<template>
    <div>
        <!-- <input class="durationInput" type="number" @change="durationChanged($event)" @keyup.enter="$refs.days[0].focus()" v-model.number="helperDuration.days">
        <label class="d-inline px-1">Days</label> -->
        <input :disabled="disabled" class="durationInput" type="number" @input="durationChanged2" @keyup.enter="$refs.minutes[0].focus()" ref="days" v-model.number="helperDuration.hours">
        <label class="d-inline px-1">Hours</label>
        <input :disabled="disabled" class="durationInput" type="number" @input="durationChanged2" ref="minutes" v-model.number="helperDuration.minutes">
        <label class="d-inline px-1">Minutes</label>

    </div>
</template>

<script>
export default {
    data:function() {
        return {

        }
    },
    props: {
        value:{
            default: "01:00"
        },
        disabled:{
            type: Boolean,
            default: false
        }
    },
    computed: {
        helperDuration:{
            get: function(){
                let exploded = this.value.split(':')
                return {
                    hours: exploded[0],
                    minutes: exploded[1]
                }
            },
            set: function(newValue) {
                if(newValue.hours < 10 && String(newValue.hours).length < 2){
                    newValue.hours = '0'+newValue.hours
                }
                if(newValue.minutes < 10 && String(newValue.minutes).length < 2){
                    newValue.minutes = '0'+newValue.minutes
                }
                let builtDuration = newValue.hours + ':' + newValue.minutes
                this.$emit('input', builtDuration)
            }
        }
    },
    methods: {
        durationChanged: function(e){
            let days = this.helperDuration.days? this.helperDuration.days : 0;
            let hours = this.helperDuration.hours? this.helperDuration.hours : 0;
            let minutes = this.helperDuration.minutes? this.helperDuration.minutes : 0;

            minutes = (minutes > 10)? minutes : '0'+minutes

            //group.duration = ((Number(days) * 24) + Number(hours)) + ':' + minutes
            // group.duration = days+'.'+hours+':'+minutes+':00'
        },
        durationChanged2: function() {
            this.helperDuration  = this.helperDuration
        }
    }
}
</script>

<style lang="scss" scoped>
//durationInput
.durationInput{
    width: 40px !important;
    display: inline-block !important;
    padding-left: 0.25rem;
    padding-right: 0.25rem;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// DurationPicker.vue?44ba2d37